var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIceCream(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A06271",
    d: "M28.59 62h9.59a2 2 0 0 0 1.96-1.61l2.49-12.43z",
    opacity: 1,
    "data-original": "#a06271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4553",
    d: "m23.74 59.84.11.56c.19.93 1.01 1.6 1.96 1.6h5.6l10.51-10.51 2.46-12.29z",
    opacity: 1,
    "data-original": "#8c4553"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A06271",
    d: "m19.78 40 2.11 10.53L32.41 40z",
    opacity: 1,
    "data-original": "#a06271"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8C4553",
    d: "m29.59 40-8.18 8.17 1.65 8.19L39.41 40z",
    opacity: 1,
    "data-original": "#8c4553"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#773545",
    d: "M36.59 40 22.58 54l1.16 5.84L43.59 40z",
    opacity: 1,
    "data-original": "#773545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A454E2",
    d: "M46.43 32.97c-.74-.5-1.64-.97-3.09-.97-1.74 0-2.67.66-3.42 1.18-.67.47-1.16.82-2.25.82s-1.58-.34-2.25-.82c-.75-.53-1.67-1.18-3.41-1.18s-2.66.66-3.41 1.18c-.67.48-1.16.82-2.26.82s-1.58-.34-2.25-.82c-.75-.53-1.68-1.18-3.42-1.18-1.46 0-2.35.46-3.09.96h-.01c-.34.16-.57.51-.57.9v4.13c0 2.21 1.79 4 4 4h22c2.21 0 4-1.79 4-4v-4.13c0-.39-.23-.74-.57-.9z",
    opacity: 1,
    "data-original": "#a454e2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C983FF",
    d: "M32 2c-4.81 0-9.33 1.87-12.73 5.27S14 15.19 14 20v7c0 .55.45 1 1 1 1.74 0 2.67-.66 3.42-1.18.67-.47 1.16-.82 2.25-.82s1.59.34 2.26.82c.75.53 1.67 1.18 3.41 1.18s2.67-.66 3.42-1.18c.67-.47 1.16-.82 2.25-.82s1.58.34 2.25.82c.75.53 1.67 1.18 3.41 1.18s2.66-.66 3.41-1.18c.67-.48 1.16-.82 2.26-.82s1.58.34 2.25.82c.75.53 1.67 1.18 3.41 1.18.55 0 1-.45 1-1v-7c0-9.93-8.07-18-18-18z",
    opacity: 1,
    "data-original": "#c983ff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA66F2",
    d: "M49 26c-1.1 0-1.58-.34-2.25-.82C46 24.65 45.08 24 43.34 24s-2.67.66-3.42 1.18c-.67.47-1.16.82-2.25.82s-1.58-.34-2.25-.82c-.75-.53-1.67-1.18-3.41-1.18s-2.66.66-3.41 1.18c-.67.48-1.16.82-2.26.82s-1.58-.34-2.25-.82c-.75-.53-1.68-1.18-3.42-1.18s-2.66.66-3.41 1.18c-.67.48-1.16.82-2.26.82-.55 0-1 .45-1 1v5.15c0 1.1.57 2.08 1.53 2.62.92.52 2 .52 2.91 0 .08-.03.12-.06.12-.07.04-.02.08-.04.12-.07.51-.35 1.01-.64 2-.64 1.1 0 1.59.34 2.26.82.75.53 1.67 1.18 3.41 1.18s2.67-.66 3.42-1.18c.67-.47 1.16-.82 2.25-.82s1.58.34 2.25.82c.75.53 1.67 1.18 3.41 1.18s2.66-.66 3.41-1.18c.67-.48 1.16-.82 2.26-.82.98 0 1.48.29 2.04.67.04.02.08.05.13.07.91.54 2.01.55 2.95.02.96-.54 1.54-1.52 1.54-2.63v-5.14c0-.55-.45-1-1-1z",
    opacity: 1,
    "data-original": "#ba66f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceCream);
export default __webpack_public_path__ + "static/media/Ice_Cream.dd0f0e50dd36011cd4b24e4bef3ab35e.svg";
export { ForwardRef as ReactComponent };